import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import moment from "moment/moment";
import {Prestazione} from "../../models/prestazione.model";
import {PrestazioneService} from "../../services/prestazione.service";
import {ActivatedRoute} from "@angular/router";
import {ScrollPositionService} from "../../services/scroll-position.service";
import {initFlowbite} from "flowbite";
import {CreateComponent} from "../../prenotazione/create/create.component";
import {EditComponent} from "../../prenotazione/edit/edit.component";
import {NgForOf} from "@angular/common";
import {AdminCalendarComponent} from "../admin-calendar/admin-calendar.component";
@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [
    CreateComponent,
    EditComponent,
    NgForOf,
    AdminCalendarComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css'
})
export class AdminComponent implements OnInit, AfterViewInit{

  @ViewChild('slide1') slide1!: ElementRef;
  @ViewChild('slide2') slide2!: ElementRef;

  //Inizio della giornata e fine della giornata
  day: string = moment().format('YYYY-MM-DD');

  //Prenotazioni
  prestazioni: Prestazione[] = [];
  prestazioni1: Prestazione[] = [];
  prestazioni2: Prestazione[] = [];

  constructor(
    public prestazioneService: PrestazioneService,
    private route: ActivatedRoute,
    private scrollPositionService: ScrollPositionService
  ) { }

  ngOnInit() {
    initFlowbite();

    this.route.params.subscribe(params => {
      this.day = params['day'] ? params['day'] : moment().format('YYYY-MM-DD');
    });

    //Recupero da BE le prestazioni
    this.prestazioneService.index()
      .subscribe((responseData) => {
        this.prestazioni = responseData.prestazioni;

        //Recupero le macchine per la prima slide
        this.prestazioni1 = this.prestazioni
          .filter(prestazione => prestazione.slide === 1);

        //Recupero le macchine per la seconda slide
        this.prestazioni2 = this.prestazioni
          .filter(prestazione => prestazione.slide === 2);
      });
  }

  addScrollListener(sourceSlide: ElementRef, targetSlides: ElementRef[]) {
    sourceSlide.nativeElement.addEventListener('scroll', (event: Event) => {
      const scrollTop = (event.target as Element).scrollTop;
      this.scrollPositionService.setScrollPosition(scrollTop);
      targetSlides.forEach(slide => {
        slide.nativeElement.scrollTop = scrollTop;
      });
    });
  }

  ngAfterViewInit() {
    const scrollPosition = this.scrollPositionService.getScrollPosition();
    this.slide1.nativeElement.scrollTop = scrollPosition;
    this.slide2.nativeElement.scrollTop = scrollPosition;

    this.addScrollListener(this.slide1, [this.slide2]);
    this.addScrollListener(this.slide2, [this.slide1]);
  }

}
